import { Form } from 'antd';
import styles from './searchGroup.less?modules';
// import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import ButtonML from '@/components/button_ml/ButtonML';
const SearchGroup = (props) => {
  const [form] = Form.useForm();

  // const onFinish = (values) => {
  //   for (let key in values) {
  //     if (!values[key]) {
  //       values[key] = undefined;
  //     }
  //   }
  //   props.handleSearch(values);
  // };

  const pushLog = () => {
    props.pushLog('add');
  };
  const onCancel = () => {
    props.onCancel();
  };
  const save = () => {
    props.save();
  };

  return (
    <Form
      form={form}
      name="control-hooks"
      // onFinish={onFinish}
      className={styles.serarchFrom}
    >
      <div className={styles.btn_contain}>
        <ButtonML
          size="large"
          value="保存"
          htmlType="submit"
          fontsize="16px"
          onClick={save}
        />
        <ButtonML
          size="large"
          value="取消"
          htmlType="submit"
          fontsize="16px"
          onClick={onCancel}
        />
        <ButtonML
          size="large"
          value="操作日志"
          fontsize="16px"
          onClick={pushLog}
        />
      </div>
    </Form>
  );
};

export default SearchGroup;
